export const compareCartQuantityWithStock = (stockQuantity: number, inCartQuantity: number): boolean => {
    const hasMaxQuantityReached = stockQuantity <= inCartQuantity;

    return !!stockQuantity && !hasMaxQuantityReached;
};
